import { Usd, Eur, All, Phone, Instagram, Place } from 'src/assets'
import {
  ROUTE_LOGIN,
  ROUTE_REGISTER,
  ROUTE_HOME,
  ROUTE_DESTINATIONS,
} from './routesConstant'

export const navbarMainTabs = [
  {
    name: 'global.home',
    link: ROUTE_HOME,
  },
  {
    name: 'global.destinations',
    link: ROUTE_DESTINATIONS,
  },
]

export const navbarExtraServices = [
  {
    name: 'global.register',
    link: ROUTE_REGISTER,
  },
  {
    name: 'global.login',
    link: ROUTE_LOGIN,
  },
]

export const passwordValidation = new RegExp(
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{9,}$/
)

export const currencies = [
  { value: 'ALL', label: 'global.ALL', icon: All },
  { value: 'EUR', label: 'global.EUR', icon: Eur },
  { value: 'USD', label: 'global.USD', icon: Usd },
]

export const footerContacts = [
  {
    label: '+355691122333',
    icon: Phone,
    to: 'tel:355691122333',
  },
  {
    icon: Instagram,
    label: 'Instagram',
    to: 'https://www.instagram.com/zuck/',
  },
  {
    icon: Place,
    label: 'Location',
    to: 'https://www.google.com/maps/place/Greenwich,+CT,+USA/@41.0519461,-73.8041594,11z/data=!3m1!4b1!4m6!3m5!1s0x89c298110f4c2e97:0x831ae27600430e2!8m2!3d41.0262417!4d-73.6281964!16zL20vMHJkNmI?entry=ttu',
  },
]

export const MONTHS_OF_YEAR = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const cardsDummyData = [
  {
    title: 'Amazing Paris Tour',
    category: 'City Breaks',
    images: [
      'https://media.istockphoto.com/id/1185953092/photo/the-main-attraction-of-paris-and-all-of-europe-is-the-eiffel-tower-in-the-rays-of-the-setting.jpg?s=2048x2048&w=is&k=20&c=IfD0giUk7Zy7DVMsTblk-MSA3rp9o980Ga_Y9X4IsrM=',
      'https://media.istockphoto.com/id/1688198071/photo/banner-of-travel-in-paris-with-eiffel-tower-iconic-paris-landmark-across-the-river-seine-with.jpg?s=2048x2048&w=is&k=20&c=i1EArQRit4yIjH8-5G2nYvKCwMdEl3MVTFrSgpjLf28=',
      'https://media.istockphoto.com/id/1688198071/photo/banner-of-travel-in-paris-with-eiffel-tower-iconic-paris-landmark-across-the-river-seine-with.jpg?s=2048x2048&w=is&k=20&c=i1EArQRit4yIjH8-5G2nYvKCwMdEl3MVTFrSgpjLf28=',
    ],
    price: 199.99,
    priceDescription: 'Per Person',
    label: 'Book Now',
    date: '2024-07-15',
  },
  {
    title: 'Grand Canyon Adventure',
    category: 'Nature Escapes',
    images: [
      'https://buckwildhummertours.com/wp-content/uploads/sites/6808/2021/12/Get-to-Know-the-Grand-Canyon-Secrets-and-the-Hidden-Waterfall.jpg?w=1000&h=1000&zoom=2',
      'https://nationalparkexpress.com/wp-content/uploads/2023/04/GCW_Banner.jpg',
      'https://nationalparkexpress.com/wp-content/uploads/2023/04/GCW_Banner.jpg',
    ],
    price: 299.99,
    priceDescription: 'All Inclusive',
    label: 'Reserve Your Spot',
    date: '2024-07-29',
  },
  {
    title: 'Safari in Africa',
    category: 'Wildlife Adventures',
    images: [
      'https://econreview.studentorg.berkeley.edu/wp-content/uploads/2023/09/safari-truck-giraffes-micato-safaris-SAFARIGUIDETIPS0721-2549bb165aa34dc193cb8b6f3958654b-e1694024338105.jpg',
      'https://www.vacationstravel.com/wp-content/uploads/2024/08/AdobeStock_525014634.jpg',
      'https://www.vacationstravel.com/wp-content/uploads/2024/08/AdobeStock_525014634.jpg',
    ],
    price: 399.99,
    priceDescription: 'Includes Guide',
    label: 'Join the Adventure',
    date: '2024-08-05',
  },
  {
    title: 'Hiking in New Zealand',
    category: 'Mountain Treks',
    images: [
      'https://www.alltrails.com/_next/image?url=https%3A%2F%2Fimages.alltrails.com%2FeyJidWNrZXQiOiJhc3NldHMuYWxsdHJhaWxzLmNvbSIsImtleSI6InVwbG9hZHMvcGhvdG8vaW1hZ2UvMjg3NTg3NTEvNTM0YmM5NDg1NjM2YTFmOWEwMmJmZWE5M2Y0MDA2NWQuanBnIiwiZWRpdHMiOnsidG9Gb3JtYXQiOiJqcGVnIiwicmVzaXplIjp7IndpZHRoIjoxMDgwLCJoZWlnaHQiOjcwMCwiZml0IjoiY292ZXIifSwicm90YXRlIjpudWxsLCJqcGVnIjp7InRyZWxsaXNRdWFudGlzYXRpb24iOnRydWUsIm92ZXJzaG9vdERlcmluZ2luZyI6dHJ1ZSwib3B0aW1pc2VTY2FucyI6dHJ1ZSwicXVhbnRpc2F0aW9uVGFibGUiOjN9fX0%3D&w=3840&q=75',
      'https://cdn.britannica.com/68/179868-138-F4FC616A/Overview-discussion-Southern-Alps-warming-New-Zealand.jpg?w=800&h=450&c=crop',
      'https://cdn.britannica.com/68/179868-138-F4FC616A/Overview-discussion-Southern-Alps-warming-New-Zealand.jpg?w=800&h=450&c=crop',
    ],
    price: 499.99,
    priceDescription: 'Per Person',
    label: 'Get Ready',
    date: '2024-12-15',
  },
  {
    title: 'Explore the Maldives',
    category: 'Island Getaways',
    images: [
      'https://static.independent.co.uk/2024/08/20/16/newFile-1.jpg?quality=75&width=640&crop=3%3A2%2Csmart&auto=webp',
      'https://images.squarespace-cdn.com/content/v1/63a23d845d55cb35462bb987/1d2e1eeb-4fb3-42d9-9361-943b2751a0db/JOALI+Maldives+Overwater+Bungalow',
      'https://images.squarespace-cdn.com/content/v1/63a23d845d55cb35462bb987/1d2e1eeb-4fb3-42d9-9361-943b2751a0db/JOALI+Maldives+Overwater+Bungalow',
    ],
    price: 699.99,
    priceDescription: 'Including Water Sports',
    label: 'Book Your Dream',
    date: '2024-12-05',
  },
]
